export enum PdiStatus {
    NotTried = "PdiStatus.NotTried",
    TextedNoResponse = "PdiStatus.TextedNoResponse",
    TextedResponse = "PdiStatus.TextedResponse",
    NoAnswer = "PdiStatus.NoAnswer",
    Reached = "PdiStatus.Reached",
    CalledIn = "PdiStatus.CalledIn",
    LeftMessage = "PdiStatus.LeftMessage"
}